import React, {useState} from 'react';
import { Form, Input, Button, Select, Tooltip } from 'antd';
import {APISaveShopping} from "../../api";

const { Option } = Select;

const countries = [
  "中国", "日本", "韩国", "泰国", "尼泊尔", "马尔代夫", "菲律宾", "朝鲜", "柬埔寨", "缅甸", "卡塔尔", "马来西亚",
  "沙特阿拉伯", "老挝", "蒙古", "印度", "叙利亚", "印度尼西亚", "阿富汗斯坦", "伊朗", "越南", "孟加拉国",
  "新加坡", "以色列", "土耳其", "美国", "法国", "德国", "英国", "加拿大", "澳大利亚", "新西兰", "意大利",
  "西班牙", "葡萄牙", "奥地利", "比利时", "挪威", "瑞典", "芬兰", "丹麦", "冰岛", "瑞士", "卢森堡", "荷兰",
  "波兰", "安道尔", "阿联酋", "巴林", "文莱"
];


const ShoppingInfo = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm()
  const handleSubmit = (values) => {
    console.log('Received values:', values);
    save(values)
  };


  const save = (values) =>{
    setLoading(true);
    APISaveShopping(JSON.stringify({
      ...values
    })).then(resp=>{
      if(resp.data){
        form.resetFields();
        setLoading(false);
        alert('感谢您的选择，请等待我们的回复');
      }
    }).catch(e=>{
      setLoading(false);
    }).finally(()=>{
      setLoading(false);
    })
  }

  return (
    <div style={{
      width:"780px",
      margin:"0 auto",
      marginTop:"80px",
    }}>
      <Form
        name="shopping_info"
        layout="vertical"
        onFinish={handleSubmit}
        form={form}
        initialValues={{
          country: '',
          productLink: '',
          contact: ''
        }}
      >
        <Form.Item
          name="country"
          label="国家"
          initialValue={"中国"}
          rules={[{ required: true, message: '请选择国家' }]}
        >
          <Select style={{
            color:"#000"
          }} placeholder="请选择国家">
            {countries.map((country) => (
              <Option key={country} value={country}>{country}</Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="link"
          label={
          <div style={{display:"flex"}}>
            商品链接
            <Tooltip title="请填写您的商品链接或店铺链接">
              <div style={{
                width:"20px",
                height:"20px",
                borderRadius:"10px",
                textAlign:"center",
                lineHeight:"20px",
                background:"#00000020",
                marginLeft:"5px"
              }}>?</div>
            </Tooltip>
          </div>
          }
          rules={[{ required: true, message: '请填写商品链接或店铺链接' }]}
        >
          <Input placeholder="请输入商品链接" />
        </Form.Item>

        <Form.Item
          name="contact"
          label="联系方式"
          rules={[{ required: true, message: '请填写联系方式' }]}
        >
          <Input placeholder="请输入联系方式" />
        </Form.Item>

        <Form.Item>
          <Button loading={loading} type="primary" htmlType="submit">
            提交
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ShoppingInfo;
